/**
 * @enum {enumCategoriesAndChannelsDataPreparationStatus} Represents status modes for preparing Categories and Channels data
 */
export enum enumCategoriesAndChannelsDataPreparationStatus {
  None = 'None',  // status hasn't been determined
  DataFetchInProgress = 'DataFetchInProgress',  // in the process of fetching data
  DataBeingProcessed = 'DataBeingProcessed',  // data has been fetched and is being processed
  DataPreparationComplete = 'DataPreparationComplete'  // data fetching and preparation operations have completed
}